import moment from 'moment';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, InputAdornment, Chip } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { NoRecordFound } from '../../../../shared_elements';
import { regexConstants } from '../../../../constants/regEx';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { numberWithCommas } from '../../../../utils';

const ShopvisitTable = ({ onMultiFieldChange, modeType, claimData, error, isReserveRate ,onFocusChange}) => {
  let headerArr = isReserveRate ? ["Module", "Description", "Fund Allocation*",] : ["Module", "Description", "Fund Balance"];
  if (claimData?.claim_event_type?.value !== 3) { headerArr = headerArr.filter(ele => ele !== "Description"); }
  const updatedEngineSplitDetails = claimData?.opening_balance_engine_split_details?.length > 0 ? claimData.opening_balance_engine_split_details : claimData?.engine_split_details ?? [];
  return (
    <>
    <TableContainer sx={{ maxHeight: "calc(100vh - 480px)", overflowY: "auto", }} component={Paper} className="scrollable-table scrollable-table-container">
      <Table size="small" className="mui-table-format" stickyHeader>
        <TableHead>
          <TableRow>
            {headerArr.map((header, idx) => (
              <TableCell key={idx} className={'nowrap-cell range-header'}>
                <b>{header}</b>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {updatedEngineSplitDetails?.length > 0 && updatedEngineSplitDetails?.map((row, index) => (
            <TableRow>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>
                {row?.module_name}
                {row?.is_non_llp && <Chip label="Non LLP" size="small" sx={{ ml: 1, fontSize: '0.7rem', height: '18px', width: '60px' }} />}
              </TableCell>
              {claimData?.claim_event_type?.value === 3 ? <TableCell>{row?.description ? row?.description : "--"}</TableCell> : null}
              {isReserveRate === true ? <> <TableCell >
                <TextField
                  required
                  defaultValue={0}
                  value={row?.fund_allocation_percentage ?? null}
                  size="small"
                  onChange={(e) => { regexConstants.percantageRegExp.test(e.target.value) ? onMultiFieldChange("engine_split_details", index, 'fund_allocation_percentage', e.target.value) : e.preventDefault() }}
                  disabled={modeType === "view"}
                  slotProps={{
                    inputLabel: { shrink: true },
                    htmlInput: {
                      maxLength: 5,
                    },
                    input: { endAdornment: (<InputAdornment position="end">%</InputAdornment>) }
                  }}
                />
              </TableCell>
                {/* <TableCell>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      required
                      label="As of Date"
                      value={row?.as_of_date ? moment(row?.as_of_date) : null}
                      onChange={(data, value) => { onMultiFieldChange("engine_split_details", row.id, "as_of_date", data ? moment(data).format(backendDateFormat) : null); }}
                      slotProps={{
                        textField: {
                          required: true,
                          label: "",
                          size: "small",
                          margin: "normal",
                          error: !!error?.[row.id],
                          helperText: error?.[row.id] || "",
                          onFocus: () => onFocusChange(row.id)
                        },
                      }}
                      // sx={{ width: "100%" }}
                      format={fieldDateFormat}
                      disabled={modeType === 'view'}
                    />
                  </LocalizationProvider>
                </TableCell> */}
              </> :
                <TableCell >
                  <TextField
                    defaultValue={0}
                    value={modeType === "view" && row?.fund_balance !== '' && row?.fund_balance !== null && row?.fund_balance !== undefined ? numberWithCommas(row?.fund_balance) : (row?.fund_balance ?? 0)}
                    size="small"
                    onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) ? onMultiFieldChange("opening_balance_engine_split_details", index, 'fund_balance', e.target.value) : e.preventDefault() }}
                    disabled={modeType === "view"}
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 }, input: { startAdornment: (<InputAdornment position="start">{claimData?.currency?.symbol}</InputAdornment>) } }}
                  />
                </TableCell>
              }
            </TableRow>)
          )}
        </TableBody>
      </Table>
    </TableContainer>
    {updatedEngineSplitDetails?.length === 0 && <NoRecordFound />}
    </>
  );
};

export default ShopvisitTable;


